import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import PageLoader from '@/app/common/components/PageLoader'
import { usePurseDistributionsQuery } from '@/queries/program_purses/usePurseDistributionsQuery'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import { PurseDetailOutletContext } from '../purse-detail-view'
import DistributionTable from './distribution-table'
import EnterPasswordDialog from './enter-password-dialog'

export default function DistributionHistoryPage() {
  const { purse } = useOutletContext<PurseDetailOutletContext>()

  const programId = useSelector(selectSelectedProgram).id
  const purseId = purse.id

  const [selectedDistributionId, setSelectedDistributionId] = useState<
    number | null
  >(null)

  const purseDistributionsQuery = usePurseDistributionsQuery({
    programId,
    purseId,
  })

  const distributions = purseDistributionsQuery.data?.distributions || []

  const selectedDistribution = distributions.find(
    (distribution) => distribution.distribution_id === selectedDistributionId
  )

  return (
    <>
      <Card>
        <CardHeader>
          <h2 className="text-xl font-semibold">Distribution History</h2>
        </CardHeader>
        <CardContent>
          <PageLoader query={purseDistributionsQuery}>
            {({ distributions }) => (
              <DistributionTable
                distributions={distributions}
                onDownloadClick={setSelectedDistributionId}
              />
            )}
          </PageLoader>
        </CardContent>
      </Card>

      {selectedDistribution && (
        <EnterPasswordDialog
          onOpenChange={() => {
            setSelectedDistributionId(null)
          }}
          distribution={selectedDistribution}
        />
      )}
    </>
  )
}
